module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/vuetable-2/~/axios/index.js
// module id = 259
// module chunks = 0